import { sequencerLogic } from './sequencer.logic';

import { SequencerHostView, SequencerProjectorView, SequencerStudentView } from './SequencerViews';

import type { ActivityPlugin } from '../../core/types/activity.types';

import { GAME_MODE_CATALOG } from '../../core/types/gameMode.types';



export const sequencerPlugin: ActivityPlugin<'order'> = {

  ...sequencerLogic,

  displayName: GAME_MODE_CATALOG.order.displayName,

  icon: GAME_MODE_CATALOG.order.icon,

  HostView: SequencerHostView,

  StudentView: SequencerStudentView,

  ProjectorView: SequencerProjectorView,

};



export { demoSequencerPayload } from './sequencer.logic';

